module.exports = __webpack_public_path__ + "static/livro-1-83f80c10e624e441ed78153fe61768e9.png";